import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { defaultTo } from 'ramda';
import * as yup from 'yup';

import EditField from '../../../components/Forms/EditField';
import { apiUpdateProfile } from '../../../api/user';
import { handleError, handleSuccess } from '../../../util/forms';

const propTypes = {
  updateUser: PropTypes.func,
  user: PropTypes.object,
};

const SocialDetails = ({
  errors,
  touched,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  isValid,
  status,
}) => (
  <form>
    <h2>Social Details</h2>
    <EditField
      as="textarea"
      name="bio"
      label="Biography"
      max={2500}
      error={errors.bio}
      status={status}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.bio}
    />
    <EditField
      name="twitterHandle"
      label="Twitter Handle"
      status={status}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.twitterHandle}
    />
    <EditField
      name="instagramProfile"
      label="Instagram Profile"
      status={status}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.instagramProfile}
    />
    <EditField
      name="linkedinProfile"
      label="LinkedIn Profile"
      status={status}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.linkedinProfile}
    />
    <hr />
    <div className="form-group row row mb-0">
      <div className="col-md-6 offset-md-4 text-right">
        <button type="submit" className="btn btn-primary" disabled={!isValid || isSubmitting} onClick={handleSubmit}>
          Save Changes
        </button>
      </div>
    </div>
  </form>
);

SocialDetails.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateProfile(payload)
      .then(({ data }) => props.updateUser(data))
      .then(() => handleSuccess(formProps))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ user }) => ({
    bio: defaultTo('', user.bio),
    twitterHandle: defaultTo('', user.twitterHandle),
    instagramProfile: defaultTo('', user.instagramProfile),
    linkedinProfile: defaultTo('', user.linkedinProfile),
  }),
  validationSchema: () =>
    yup.object().shape({
      bio: yup.string().max(2500, 'Too many characters'),
    }),
  isInitialValid: ({ initialValues, validationSchema }) => validationSchema().isValidSync(initialValues),
  validateOnChange: true,
})(SocialDetails);
